import { render, staticRenderFns } from "./table-td.vue?vue&type=template&id=ff9c047a&"
import script from "./table-td.vue?vue&type=script&lang=js&"
export * from "./table-td.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports